import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import clanames from 'classnames/bind';

import styles from './Breadcrumbs.module.scss'

const cx = clanames.bind(styles)

const Breadcrumbs = ({ steps, active, className }) => {
  const items = useMemo(function () {
    return steps.map((el, i) => {
      return {
        ...el,
        isChecked: i < active,
        Tag: el.url ? 'a' : 'span'
      }
    })
  }, [steps, active])

  const handleClick = (gtm) => {
    if (window.dataLayer && gtm) {
      return window.dataLayer.push(gtm);
    }
    return null;
  };

  return (
    <ul className={cx('breadcrumbs', className)}>
      {items.map(({label, gtm, url, isChecked, Tag}, i, arr) => (
        <li key={uuidv4()}>
          <Tag href={url} onClick={() => handleClick(gtm)}>
            <span className={cx('step-icon')}>
              {!isChecked ? i + 1 : ''}
            </span>
            <p className={cx('step-text')}>
              {label}
            </p>
          </Tag>
        </li>
      ))}
    </ul>
  );
};

Breadcrumbs.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.string,
    gtm: PropTypes.shape({}),
  })).isRequired,
  active: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  className: PropTypes.string
};

Breadcrumbs.defaultProps = {
  className: ''
}

export default Breadcrumbs;
